import React from 'react';
import RequestsCuttingTable from "../../../../components/UI/table/optimization/requestscutting/RequestsCuttingTable";
import RequestsCuttingService from "../../../../API/orders/optimization/organization/RequestsCuttingService";
import Typography from "@mui/material/Typography";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";

const RequestsCuttingsArchive = () => {
    const enableRowSelection = (state) => {
        return ["EXPECTATION", "FORMED_OPTIMIZATION"].includes(state)
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Архив`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заказы", href: "/organization/orders"},
                    {name: "Заявки на раскрой", href: "/organization/requests-cutting"},
                ]}/>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                Архив заявок на раскрой
            </Typography>
            <RequestsCuttingTable
                getAll={RequestsCuttingService.getAllArchive}
                isOptimization={true}
                isArchive={true}
                isRedirectRequestsCutting={false}
                isButtonAddRequestsCutting={false}
                isOrder={true}
                isPlan={true}
                isAddOptimization={true}
                isCreateOptimization={true}
                isRedirectPlans={true}
                isRedirectOptimizations={true}
                isRedirectOrders={true}
                page={'RequestsCuttingsAll'}
                isCalculation={false}
                isDeleteOptimization={true}
                enableRowSelection={enableRowSelection}
            />
        </Box>
    );
};

export default RequestsCuttingsArchive;